module.exports = __webpack_public_path__ + "img/solidworks_banner.ef8a6aaf.jpg";